// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__KDL9W","icon":"Loading_icon__BBqZA"};